import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import type { AuditResponse } from 'shared/audit/api/auditResponse';

export interface ProductGroupAuditRequest {
  id: string;
}

export interface ProductGroupAuditResponse {
  ok: true;
  audit: AuditResponse;
}

export function useProductGroupAuditApi() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: ProductGroupAuditRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`audit/product/group/${action.id}`), {
      headers
    });

    const text = translations.value.audit.actions.fetchProductGroup;

    const response = await httpClient.action<ProductGroupAuditResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const audit = await response.json() as AuditResponse;

        return {
          ok: true,
          audit: audit
        };
      },
    });

    return response;
  }
}
